import {
  choosePlan,
  fetchSubscriptions,
  getSubscriptionsCreditsHistory,
  rechargeCredits,
} from "./asyncThunks";

export const choosePlanBuilder = (builder) => {
  builder.addCase(choosePlan.pending, (state) => {
    state.choosePlanPending = true;
  });
  builder.addCase(choosePlan.fulfilled, (state, { payload }) => {
    state.choosePlanPending = false;
  });
  builder.addCase(choosePlan.rejected, (state) => {
    state.choosePlanPending = false;
  });
};

export const rechargeCreditsBuilder = (builder) => {
  builder.addCase(rechargeCredits.pending, (state) => {
    state.rechargeCreditsPending = true;
  });
  builder.addCase(rechargeCredits.fulfilled, (state, { payload }) => {
    state.rechargeCreditsPending = false;
  });
  builder.addCase(rechargeCredits.rejected, (state) => {
    state.rechargeCreditsPending = false;
  });
};

export const fetchSubscriptionsBuilder = (builder) => {
  builder.addCase(fetchSubscriptions.pending, (state) => {
    state.fetchSubscriptionsPending = true;
  });
  builder.addCase(fetchSubscriptions.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.subscriptions = data;
    state.fetchSubscriptionsPending = false;
  });
  builder.addCase(fetchSubscriptions.rejected, (state) => {
    state.fetchSubscriptionsPending = false;
  });
};

export const getSubscriptionsCreditsHistoryBuilder = (builder) => {
  builder.addCase(getSubscriptionsCreditsHistory.pending, (state) => {
    state.creditsHistory.loadings = true;
  });
  builder.addCase(
    getSubscriptionsCreditsHistory.fulfilled,
    (state, { payload }) => {
      const { data, total, page, perPage, maxReached } = payload;
      state.creditsHistory.data = data;
      state.creditsHistory.maxReached = maxReached;
      state.creditsHistory.perPage = +perPage;
      state.creditsHistory.page = +page;
      state.creditsHistory.total = +total;
      state.creditsHistory.loadings = false;
    }
  );
  builder.addCase(getSubscriptionsCreditsHistory.rejected, (state) => {
    state.creditsHistory.loadings = false;
  });
};
